import ItemComboSFC from "./ItemCombo.vue";
export type { IItemComboEmits } from "./emits";
export const ItemCombo = ItemComboSFC;
